import React from "react";
import { withJsonFormsOneOfEnumProps } from "@jsonforms/react";
import { and, isOneOfEnumControl, optionIs, rankWith } from "@jsonforms/core";

export const materialOneOfRadioGroupControl = (props) => {
  if (!props.visible) {
    return null;
  }

  return (
    <>
      <strong>{props.label}:</strong>&nbsp;
      {props.options.find((option) => option.value === props.data)?.label}
    </>
  );
};

export const materialOneOfRadioGroupControlTester = rankWith(
  25,
  and(isOneOfEnumControl, optionIs("format", "radio")),
);

// Wrap the renderer with JSONForms control props
export default withJsonFormsOneOfEnumProps(materialOneOfRadioGroupControl);
